// Urls
export const GET_CLIENT_EVENTS = "/v2/clients/:clientId/:eventTypes";
export const GET_EVENT_DETAILS = "/v2/events/:eventId/media-formats/:eventType";
export const STRETCH_FETCH_EVENT_TYPES = "/v2/events/all-types";
export const GET_PRODUCTS_FOR_EVENT = "/v2/events/:eventId/products";
export const STREAM_ACTIVITY_RECORD = "/v2/streams/:eventId/record";

// Constants
export const FETCH_EVENT_LIST = "FETCH_EVENT_LIST";
export const FETCH_EVENT_LIST_DONE = "FETCH_EVENT_LIST_DONE";
export const FETCH_EVENT_LIST_ERROR = "FETCH_EVENT_LIST_ERROR";

export const EVENT_SELECTED = "EVENT_SELECTED";
export const CLEAR_EVENT_DETAILS = "CLEAR_EVENT_DETAILS";

export const FETCH_EVENT_DETAILS = "FETCH_EVENT_DETAILS";
export const FETCH_EVENT_DETAILS_DONE = "FETCH_EVENT_DETAILS_DONE";
export const FETCH_EVENT_DETAILS_ERROR = "FETCH_EVENT_DETAILS_ERROR";

export const FETCH_EVENT_TYPES = "FETCH_EVENT_TYPES";
export const FETCH_EVENT_TYPES_DONE = "FETCH_EVENT_TYPES_DONE";
export const FETCH_EVENT_TYPES_ERROR = "FETCH_EVENT_TYPES_ERROR";

export const FETCH_EVENT_PRODUCTS = "FETCH_EVENT_PRODUCTS";
export const FETCH_EVENT_PRODUCTS_DONE = "FETCH_EVENT_PRODUCTS_DONE";
export const FETCH_EVENT_PRODUCTS_ERROR = "FETCH_EVENT_PRODUCTS_ERROR";

export const STORE_SELECTED_PRODUCT = "STORE_SELECTED_PRODUCT";

export const FETCH_EVENT_STATUS_DONE = "FETCH_EVENT_STATUS_DONE";
export const CLEAR_EVENT_STATUS = "CLEAR_EVENT_STATUS";

export const RECORD_STREAM_ACTIVITY = "RECORD_STREAM_ACTIVITY";
export const RECORD_STREAM_ACTIVITY_DONE = "RECORD_STREAM_ACTIVITY_DONE";
export const RECORD_STREAM_ACTIVITY_ERROR = "RECORD_STREAM_ACTIVITY_ERROR";

export const ENDPOINTS_TAB = [
  {
    tabName: "on-demand",
    endpoint: "ondemand"
  },
  {
    tabName: "scheduled",
    endpoint: "scheduled"
  }
];
